"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterPlainResults = void 0;
var CallbackTypes_1 = require("../../CallbackTypes");
var callbackDictionary_1 = require("../callbackDictionary");
var isValidCallbackType = function (type) {
    return type in CallbackTypes_1.CallbackTypes;
};
var isValidResult = function (result) {
    if (result && typeof result === "object") {
        return result;
    }
    return null;
};
var findValue = function (result, path) {
    var properties = path.split(".");
    var value = properties.reduce(function (item, property) {
        var validItem = isValidResult(item);
        if (!validItem) {
            return null;
        }
        return validItem[property];
    }, result);
    return value;
};
function filterPlainResults(results, appliedFiltersValues) {
    var orLogicOperator = "OR";
    var filteredResults = results.filter(function (result) {
        var item = isValidResult(result);
        if (!item) {
            return false;
        }
        var filtersConditions = appliedFiltersValues.reduce(function (conditions, _a) {
            var type = _a.type, path = _a.path, value = _a.value, logic = _a.logic;
            if (!isValidCallbackType(type)) {
                conditions.and.push(false);
                return conditions;
            }
            var validType = type;
            var callback = callbackDictionary_1.callbackDictionary[validType];
            var resultValue = findValue(item, path);
            var filterValue = value;
            var condition = callback(resultValue, filterValue);
            logic === orLogicOperator
                ? conditions.or.push(condition)
                : conditions.and.push(condition);
            return conditions;
        }, {
            or: [],
            and: [],
        });
        var andConditions = filtersConditions.and.length
            ? filtersConditions.and.every(function (condition) { return condition; })
            : true;
        var orConditions = filtersConditions.or.length
            ? filtersConditions.or.some(function (condition) { return condition; })
            : true;
        return andConditions && orConditions;
    });
    return filteredResults;
}
exports.filterPlainResults = filterPlainResults;
//# sourceMappingURL=filterPlainResults.js.map